module.exports = __webpack_public_path__ + "static/media/gaspar-regular.1a255170.ttf";